import { TableCell } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Check from '@material-ui/icons/Check';

const TableAdminCheckboxSection = ({
  mailingOption,
  t,
  openToast,
  state,
  setState,
  classes,
}) => {
  return (
    <TableCell>
      {mailingOption.mailKey !== 'diet_reminder' && (
        <Checkbox
          checked={
            mailingOption.managedBySystem
              ? true
              : mailingOption.enabledForOffice
          }
          onChange={e => {
            if (mailingOption.managedBySystem) {
              return openToast({
                messages: [
                  t(
                    'mailNotifications.thisIsASystemNotification',
                    'To powiadomienie, jest powiadomieniem systemowym.'
                  ),
                  t(
                    'mailNotifications.cannotDisabeSystemNotification',
                    'Nie możesz wyłączyć powiadomienia systemowego.'
                  ),
                ],
                type: 'warning',
                autoHideDuration: 5000,
              });
            }

            const newMailing = [...state.mailing];

            const optionToChange = newMailing.find(
              newMailingOption => newMailingOption.id === mailingOption.id
            );

            optionToChange.enabledForOffice = !mailingOption.enabledForOffice;
            optionToChange.hasChanged = true;

            setState({
              mailing: newMailing,
            });
          }}
          checkedIcon={<Check className={classes.checkedIcon} />}
          icon={<Check className={classes.uncheckedIcon} />}
          classes={{
            checked: classes.checked,
            root: classes.checkRoot,
          }}
        />
      )}
    </TableCell>
  );
};

export default TableAdminCheckboxSection;
